var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49 49",
    style: {
      enableBackground: "new 0 0 49 49"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    },
    cx: 24.5,
    cy: 24.5,
    r: 24
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 23.2,
    r: 8.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 48.5c-9.5 0-18.8-7.4-18.3-8.4 2.3-4.4 9.5-9.4 18.1-9.4s16.1 5.1 18.4 9.4c.6 1-8.6 8.4-18.2 8.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfileIcon);
export default __webpack_public_path__ + "static/media/user-profile-icon.06197fbf14da4b513306175442782fc7.svg";
export { ForwardRef as ReactComponent };